/**
 * @file tools 页 api
 * 这一组接口由于不规范，所以就单独处理
 * @author FengGuang(fengguang01@baidu.com)
 */
import request from 'superagent';
import baseRequest from '../baseApi';

// 获取工具页数据
export const fetchGetToolsList = (): Promise<request.Response> =>
    baseRequest(
        request.get('/platform/content/list')
            .query({contentType: 'paddleOrgTools'})
    );
